module.exports = __webpack_public_path__ + "img/rek_hover_754af66.webp";